// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.bs.js");
var MM_parenCounter = require("../mm-utils/MM_parenCounter.bs.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var Expln_utils_jsonParse = require("@expln/utils/src/main/Expln_utils_jsonParse.bs.js");

function userStmtLocStorToUserStmt(userStmtLocStor) {
  return {
          id: "",
          label: userStmtLocStor.label,
          labelEditMode: false,
          typ: MM_wrk_editor.userStmtTypeFromStr(userStmtLocStor.typ),
          typEditMode: false,
          cont: MM_wrk_editor.strToCont(userStmtLocStor.cont, undefined, undefined, undefined),
          contEditMode: false,
          jstfText: userStmtLocStor.jstfText,
          jstfEditMode: false,
          stmtErr: undefined,
          expr: undefined,
          jstf: undefined,
          proofTreeDto: undefined,
          src: undefined,
          proof: undefined,
          proofStatus: undefined,
          unifErr: undefined,
          syntaxErr: undefined
        };
}

function createInitialEditorState(settingsV, settings, srcs, preCtxV, preCtx, stateLocStor) {
  var st_typeColors = Belt_HashMapString.make(0);
  var st_parenCnt = MM_parenCounter.parenCntMake([], undefined, undefined);
  var st_preCtxColors = Belt_HashMapString.make(0);
  var st_syntaxTypes = [];
  var st_parensMap = Belt_HashMapString.make(0);
  var st_descr = Belt_Option.getWithDefault(Belt_Option.map(stateLocStor, (function (obj) {
              return obj.descr;
            })), "");
  var st_varsText = Belt_Option.getWithDefault(Belt_Option.map(stateLocStor, (function (obj) {
              return obj.varsText;
            })), "");
  var st_wrkCtxColors = Belt_HashMapString.make(0);
  var st_disjText = Belt_Option.getWithDefault(Belt_Option.map(stateLocStor, (function (obj) {
              return obj.disjText;
            })), "");
  var st_disj = Belt_MapInt.fromArray([]);
  var st_nextStmtId = Belt_Option.getWithDefault(Belt_Option.map(stateLocStor, (function (stateLocStor) {
              return stateLocStor.stmts.length;
            })), 0);
  var st_stmts = Belt_Option.getWithDefault(Belt_Option.map(stateLocStor, (function (obj) {
              return obj.stmts.map(function (stmtLocStor, i) {
                          var init = userStmtLocStorToUserStmt(stmtLocStor);
                          return {
                                  id: String(i),
                                  label: init.label,
                                  labelEditMode: init.labelEditMode,
                                  typ: init.typ,
                                  typEditMode: init.typEditMode,
                                  cont: init.cont,
                                  contEditMode: init.contEditMode,
                                  jstfText: init.jstfText,
                                  jstfEditMode: init.jstfEditMode,
                                  stmtErr: init.stmtErr,
                                  expr: init.expr,
                                  jstf: init.jstf,
                                  proofTreeDto: init.proofTreeDto,
                                  src: init.src,
                                  proof: init.proof,
                                  proofStatus: init.proofStatus,
                                  unifErr: init.unifErr,
                                  syntaxErr: init.syntaxErr
                                };
                        });
            })), []);
  var st_checkedStmtIds = [];
  var st = {
    settingsV: settingsV,
    settings: settings,
    typeColors: st_typeColors,
    srcs: srcs,
    preCtxV: preCtxV,
    preCtx: preCtx,
    frms: undefined,
    parenCnt: st_parenCnt,
    preCtxColors: st_preCtxColors,
    syntaxTypes: st_syntaxTypes,
    parensMap: st_parensMap,
    descr: st_descr,
    descrEditMode: false,
    varsText: st_varsText,
    varsEditMode: false,
    varsErr: undefined,
    wrkCtxColors: st_wrkCtxColors,
    disjText: st_disjText,
    disjEditMode: false,
    disjErr: undefined,
    disj: st_disj,
    wrkCtx: undefined,
    nextStmtId: st_nextStmtId,
    stmts: st_stmts,
    checkedStmtIds: st_checkedStmtIds,
    unifyAllIsRequiredCnt: 0
  };
  var st$1 = MM_wrk_editor.setSettings(st, settingsV, settings);
  return MM_wrk_editor.setPreCtx(st$1, st$1.srcs, preCtxV, preCtx);
}

function editorStateToEditorStateLocStor(state) {
  return {
          srcs: state.srcs,
          descr: state.descr,
          varsText: state.varsText,
          disjText: state.disjText,
          stmts: state.stmts.map(function (stmt) {
                return {
                        label: stmt.label,
                        typ: MM_wrk_editor.userStmtTypeToStr(stmt.typ),
                        cont: MM_wrk_editor.contToStr(stmt.cont),
                        jstfText: stmt.jstfText
                      };
              })
        };
}

function readEditorStateFromJsonStr(jsonStr) {
  return Expln_utils_jsonParse.parseJson(jsonStr, (function (__x) {
                return Expln_utils_jsonParse.asObj(__x, (function (d) {
                              return {
                                      srcs: Expln_utils_jsonParse.arr(d, "srcs", (function (__x) {
                                              return Expln_utils_jsonParse.asObj(__x, (function (d) {
                                                            return {
                                                                    typ: Expln_utils_jsonParse.str(d, "typ", undefined, undefined, undefined),
                                                                    fileName: Expln_utils_jsonParse.str(d, "fileName", undefined, undefined, undefined),
                                                                    url: Expln_utils_jsonParse.str(d, "url", undefined, undefined, undefined),
                                                                    readInstr: Expln_utils_jsonParse.str(d, "readInstr", undefined, undefined, undefined),
                                                                    label: Expln_utils_jsonParse.str(d, "label", undefined, undefined, undefined)
                                                                  };
                                                          }), undefined, undefined, undefined);
                                            }), undefined, (function (param) {
                                              return [];
                                            }), undefined),
                                      descr: Expln_utils_jsonParse.str(d, "descr", undefined, (function (param) {
                                              return "";
                                            }), undefined),
                                      varsText: Expln_utils_jsonParse.str(d, "varsText", undefined, (function (param) {
                                              return "";
                                            }), undefined),
                                      disjText: Expln_utils_jsonParse.str(d, "disjText", undefined, (function (param) {
                                              return "";
                                            }), undefined),
                                      stmts: Expln_utils_jsonParse.arr(d, "stmts", (function (__x) {
                                              return Expln_utils_jsonParse.asObj(__x, (function (d) {
                                                            return {
                                                                    label: Expln_utils_jsonParse.str(d, "label", undefined, undefined, undefined),
                                                                    typ: Expln_utils_jsonParse.str(d, "typ", undefined, undefined, undefined),
                                                                    cont: Expln_utils_jsonParse.str(d, "cont", undefined, undefined, undefined),
                                                                    jstfText: Expln_utils_jsonParse.str(d, "jstfText", undefined, undefined, undefined)
                                                                  };
                                                          }), undefined, undefined, undefined);
                                            }), undefined, undefined, undefined)
                                    };
                            }), undefined, undefined, undefined);
              }), undefined, undefined, undefined);
}

exports.userStmtLocStorToUserStmt = userStmtLocStorToUserStmt;
exports.createInitialEditorState = createInitialEditorState;
exports.editorStateToEditorStateLocStor = editorStateToEditorStateLocStor;
exports.readEditorStateFromJsonStr = readEditorStateFromJsonStr;
/* MM_wrk_editor Not a pure module */
